import { createFeatureSelector, createSelector } from '@ngrx/store';

import { GroupMember } from '@era/security-sdk';
import { selectCurrentGroupId } from '../router/security-router.selector';
import * as fromMemberUser from './member-user.reducer';
import { MemberUserState } from './member-user.state';

export const selectMemberUserState = createFeatureSelector<MemberUserState>('memberUsers');

export const selectAllMemberUsers = createSelector(selectMemberUserState, fromMemberUser.selectAllMemberUsers);

export const selectGroupByParentId = (parentId: string) =>
  createSelector(selectAllMemberUsers, (groupMember: GroupMember[]) =>
    groupMember ? groupMember.filter((member) => member.parentId === parentId) : []
  );

export const selectCurrentGroupUsers = createSelector(
  selectCurrentGroupId,
  selectAllMemberUsers,
  (currentGroupId: string, groupMember: GroupMember[]) =>
    groupMember && currentGroupId ? groupMember.filter((group) => group.parentId === currentGroupId) : []
);
